import React, { useRef } from 'react';

import { useMenuItemNavigation } from '../../../SlideOutNav/hooks/use-menu-item-navigation';

import styles from '../SpecialistShopsLinks.scss';

const formatShopLink = link =>
  link.tracking
    ? `${link.url}?utm_source=waitrose.com&utm_medium=referral&utm_campaign=${link.tracking}`
    : link.url;

const SpecialistShopLink = ({ link, target }) => {
  const ref = useRef(null);
  const { handleClick, handleKeyDown, tabIndex } = useMenuItemNavigation(ref);

  return (
    <a
      className={styles.link}
      href={formatShopLink(link)}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      ref={ref}
      rel="noopener noreferrer"
      tabIndex={Number(tabIndex)}
      target={target || '_blank'}
    >
      {link?.name}
    </a>
  );
};

SpecialistShopLink.propTypes = {
  link: {
    name: String,
    tracking: String,
    url: String,
  }.isRequired,
  target: String,
};

SpecialistShopLink.defaultProps = {
  target: undefined,
};

SpecialistShopLink.displayName = 'SpecialistShopLink';

export default SpecialistShopLink;
